import { Banner } from '../banner/banner';
import { Niche } from '../niche/niche';

export interface Store {
    id: string;
    userId: number;
    niche: Niche;
    banners?: Banner[];
    storeUrl?: string;
    dropshipper?: StoreType;
    appInstalled: boolean;
    status: StoreStatus;
    subscribed: boolean;
    updatedAt: Date;
}

export interface UpdateStoreRequest {
    nicheId?: number;
    banners?: { id: number }[];
    storeUrl?: string;
    dropshipper?: StoreType;
}

export enum StoreType {
    DROPSHIPPER = 'DROPSHIPPER',
    BRANDED_STORE = 'BRANDED_STORE',
}

export enum StoreStatus {
    DRAFT = 'DRAFT',
    DELETED = 'DELETED',
    PUBLISHED = 'PUBLISHED',
    CREATED = 'CREATED',
}
